import Import from './Import/Import';
import Export from './Export/Export';
import './tools.scss';
import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import AppDate from './AppDate/AppDate';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const Tools = () => {
  const [value, setValue] = useState<number>(0);
  const env = process.env.REACT_APP_ENV;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  };

  return env !== 'prod' && env !== 'preprod' ? (
    <div className="wrapper-inputs">
      <Tabs value={value} onChange={handleChange} centered>
        <Tab label="Import / Export" {...a11yProps(0)} />
        <Tab label="Réglage date" {...a11yProps(1)} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <Export />
        <Import />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AppDate />
      </CustomTabPanel>
    </div>
  ) : (
    <div className="wrapper-inputs">
      <Export />
      <Import />
    </div>
  );
};

export default Tools;
